import { maybeNum, num, obj, str } from "@agrigate/ts-utils/lib/zod";
import { PaymentMode } from "../../enums";
export * from "./geo-scope";
export * from "./pagination";
export const QualityBasedPBStlItemAdjustment = obj({
    variationId: str,
    thresholdId: str,
    fieldName: str,
    fieldValue: str,
    percentChange: num,
});
export const PaymentBasedPBStlItemAdjustment = obj({
    paymentMode: PaymentMode,
    settlementDays: maybeNum,
    percentChange: num,
});
export const PBStlItemAdjustments = obj({
    qualityBased: QualityBasedPBStlItemAdjustment.array().nullish(),
    paymentBased: PaymentBasedPBStlItemAdjustment.array().nullish(),
});
//# sourceMappingURL=index.js.map